import { ACTIONS } from "./actions";

const initialState = {
    loading: false,
    success: false,
    error: null,
};

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case ACTIONS.UPDATE_FREESHIPPING_RULE_LOADING:
            return {
                ...state,
                loading: true,
            };
        case ACTIONS.UPDATE_FREESHIPPING_RULE_SUCCESS:
            return {
                ...state,
                loading: false,
                success: true,
                error: null,
            };
        case ACTIONS.UPDATE_FREESHIPPING_RULE_ERROR:
            return {
                ...state,
                loading: false,
                success: false,
                error: action.payload,
            };

        default:
            return state;
    }
};

export default reducer;
